// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_22e94dc","betDetails":"_fce5313","meta":"_cafc927","bonusCash":"_a8695f6"};